//import { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import Events from './Events';
import Home from './Home';
import VenThero from './VenThero';
import Purpose from './Purpose';
import Temples from './Temples';
import SundaySchool from './SundaySchool';
import Donate from './Donate';
import ContactUs from './ContactUs';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <Events />,
  },
  {
    path: "/home",
    element: <Home />
  },
  {
    path: "/venThero",
    element: <VenThero />
  },
  {
    path: "/purpose",
    element: <Purpose />
  },
  {
    path: "/temples",
    element: <Temples />
  },
  {
    path: "/events",
    element: <Events />
  },
  {
    path: "/sundaySchool",
    element: <SundaySchool />
  },
  {
    path: "/donate",
    element: <Donate />
  },
  {
    path: "/contactUs",
    element: <ContactUs />
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
